import { FaCheck } from "react-icons/fa";
import { useDispatch } from "react-redux";

//redux
import { selectStepService } from "../../../../store/service/service.action";

//outsource
import { Modal, Button } from "antd";

const DialogConsultationSuccess = ({ open, setOpenSuccess }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION --------------------------

  const handleDone = () => {
    setOpenSuccess(false);
    selectStepService(dispatch, 0);
  };

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------
  const renderButtonFooter = () => {
    return (
      <Button className="btn-booking-done" onClick={handleDone} type="primary">
        OK
      </Button>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <Modal
      open={open}
      title={null}
      closable={false}
      footer={renderButtonFooter()}
    >
      <div style={{ textAlign: "center", padding: "0px 30px" }}>
        <h1 className="success-booking-title">Thank You</h1>
        <FaCheck size={60} color={"green"} />
        <p style={{ fontSize: 18 }}>
          Please keep your phone nearby — we’ll contact you during your selected
          time slot.
        </p>
      </div>
    </Modal>
  );
};

export default DialogConsultationSuccess;
